import { cn } from '../../lib/utils'
import { StatusDot } from './StatusDot'
import type { Status } from './types'

export interface StatusPillProps extends React.HTMLAttributes<HTMLSpanElement> {
  status?: Status
  withDot?: boolean
}

const TONE: Record<Status, string> = {
  run: 'text-st-run bg-st-run-bg border-transparent',
  warn: 'text-st-warn bg-st-warn-bg border-transparent',
  down: 'text-st-down bg-st-down-bg border-transparent',
  idle: 'text-ink-2 bg-st-idle-bg border-transparent',
  info: 'text-st-info bg-st-info-bg border-transparent'
}

export function StatusPill({
  status = 'idle',
  withDot = true,
  className,
  children,
  ...rest
}: StatusPillProps) {
  return (
    <span
      data-st={status}
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border border-line px-2 py-px text-11 font-medium tracking-[0.01em]',
        'transition-colors duration-200 ease-out',
        TONE[status],
        className
      )}
      {...rest}
    >
      {withDot && <StatusDot status={status} />}
      {children}
    </span>
  )
}
